module.exports = __webpack_public_path__ + "img/copy.f7b9c6d5.svg";